export const keyCodes = {
  SPACE: 32,
  ENTER: 13,
};
